const GA_ID = 'G-4MQ931G1T5';

export function fireGAEvent(eventName, params = {}) {
  if (typeof window.gtag !== 'function') {
    // console.warn('❌ GA tracking failed: gtag is not defined');
    return;
  }

  const deviceType = getDeviceType();

  const enrichedParams = {
    ...params,
    device_type: deviceType,
    send_to: GA_ID,
  };

  window.gtag('event', eventName, enrichedParams);

  if (params.screen_name) {
    // console.log(`✅ GA4 event: '${eventName}' sent to ${GA_ID}`);
    // console.log(`   🔹 screen_name: ${params.screen_name}`);
    // console.log(`   📱 device_type: ${deviceType}`);
  } else {
    //console.log(`✅ GA4 event: '${eventName}' sent to ${GA_ID}`);
    if (params.event_label) {
      // console.log(`   🔹 event_label: ${params.event_label}`);
    }
    // console.log(`   📱 device_type: ${deviceType}`);
  }
}

export function trackScreenView(screenName) {
  fireGAEvent('screen_view', {
    screen_name: screenName,
    app_version: '1.0.0',
    device_type: getDeviceType(),
  });
}

export function trackClick(label) {
  fireGAEvent('click', {
    event_category: 'CTA',
    event_label: label,
  });
}

export function getDeviceType() {
  const width = window.innerWidth;
  if (width <= 768) return 'mobile';
  if (width <= 1024) return 'tablet';
  return 'desktop';
}